module.exports = __webpack_public_path__ + "static/media/user-minus.cf6b2f84.svg";